module.exports = __webpack_public_path__ + "static/logo-fc8e568bcf6f3a2cf1149069690d26b9.png";